/* eslint-disable radix */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import {
  getAllTrikesV3,
  getTrikesKPI,
  getTrikesV3,
  retireTrike,
} from "../../../Redux/APIs/trikesAPI";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import { DEFAULT_LIMIT } from "../../../Utils/constants";
import { TRIKE_STATUS } from "../Data";
import RetireIcon from "../../../Common/Svgs/RetireIcon";

const ongoingTripStatus = [
  TRIKE_STATUS.ON_TRIP,
  TRIKE_STATUS.OUT_OF_GEOFENCE,
  TRIKE_STATUS.DISPATCHED,
];

const RetireTrikeModal = ({
  visible,
  onCancel,
  trikeCurrentPage,
  setTrikeCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { retireTrikeModal, currentTrike } = useSelector(
    (state) => state.trikes,
  );

  const onConfirm = async () => {
    await dispatch(retireTrike({ trikeId: retireTrikeModal.id }));

    const response = await dispatch(
      getTrikesV3({
        offset: ((trikeCurrentPage || 1) - 1) * DEFAULT_LIMIT,
        limit: DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && trikeCurrentPage > 1) {
      const previousPage = trikeCurrentPage - 1;
      setTrikeCurrentPage(previousPage);

      await dispatch(
        getTrikesV3({
          offset: (previousPage - 1) * DEFAULT_LIMIT,
          limit: DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(getTrikesKPI());
    dispatch(getAllTrikesV3());

    dispatch(
      updateTrikes({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Trike retired.",
            description: `Trike ${
              retireTrikeModal?.registrationNo || "1 trike"
            } was retired successfully.`,
          },
        },
      }),
    );

    onCancel();
  };

  const getBody = () => {
    if (ongoingTripStatus.includes(+currentTrike.status)) {
      return (
        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Cannot retire trike
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            The trike is currently on trip.
          </p>
        </div>
      );
    }

    return (
      <div className="px-2 mt-5">
        <p className="text-base font-medium text-alert-red font-poppins">
          Retire this trike
        </p>
        <p className="mt-2 text-xs font-normal text-black font-aileron">
          Are you sure you want to retire this trike?
        </p>
      </div>
    );
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <CustomRoundedImage
            size="w-12 h-12"
            image={<RetireIcon size={24} className="text-white" />}
            background="bg-primary"
          />

          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>

        {getBody()}

        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>

          {/* do not show the confirm button if trike is currently on trip or
          dispatch */}
          {!ongoingTripStatus.includes(+currentTrike.status) && (
            <Button colors="alert" size="primary" onClick={onConfirm}>
              Confirm
            </Button>
          )}
        </div>
      </div>
    </CustomModal>
  );
};

export default RetireTrikeModal;
